export default {
  name: 'slate',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#446b7c',
  borderDarkest: '#000814',
  borderLight: '#adc8da',
  borderLightest: '#c3d9e9',
  canvas: '#f2ffff',
  canvasText: '#00010f',
  canvasTextDisabled: '#446b7c',
  canvasTextDisabledShadow: '#c3d9e9',
  canvasTextInvert: '#f2ffff',
  checkmark: '#00010f',
  checkmarkDisabled: '#446b7c',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#448199',
  headerNotActiveBackground: '#807f80',
  headerNotActiveText: '#c2c1c2',
  headerText: '#f2ffff',
  hoverBackground: '#448199',
  material: '#97b9cb',
  materialDark: '#9a9e9c',
  materialText: '#00010f',
  materialTextDisabled: '#446b7c',
  materialTextDisabledShadow: '#c3d9e9',
  materialTextInvert: '#f2ffff',
  progress: '#448199',
  tooltip: '#fefbcc'
};
